module.exports = __webpack_public_path__ + "img/qr_scan_wrong.d7b62771.svg";